import { getDocs } from 'firebase/firestore/lite';
import { buildingsCollection } from '@/firebase';

const getAllBuildings = async () => getDocs(buildingsCollection);

export {
  // eslint-disable-next-line import/prefer-default-export
  getAllBuildings,
};
